var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLetter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "24 11 360 360",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,420) scale(0.1,-0.1)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2505 4014 c-497 -69 -952 -250 -1355 -537 -214 -152 -362 -304 -479 -492 -173 -276 -180 -487 -21 -646 80 -81 151 -112 269 -117 88 -4 195 10 205 26 2 4 -16 32 -41 62 -125 150 -146 318 -63 521 165 406 711 824 1268 970 96 26 143 32 262 36 215 8 338 -23 436 -109 248 -218 242 -867 -14 -1423 -130 -281 -305 -537 -516 -753 -226 -232 -394 -304 -589 -251 -36 9 -39 13 -34 38 3 15 76 227 162 472 87 244 222 631 301 859 263 754 248 715 307 797 17 24 27 46 24 50 -13 12 -179 -18 -263 -48 -156 -57 -249 -136 -333 -283 -76 -133 -197 -466 -402 -1101 -65 -203 -139 -424 -163 -490 l-44 -120 -89 -1 c-152 -1 -242 -20 -386 -83 -182 -79 -430 -289 -496 -418 -63 -125 -20 -254 107 -321 168 -89 458 -73 689 37 160 77 302 195 410 340 31 42 59 79 63 84 3 4 37 -4 75 -18 193 -73 418 -75 626 -4 568 192 1087 885 1256 1679 14 67 18 130 18 295 0 239 -13 309 -85 462 -49 104 -89 162 -163 235 -114 113 -238 181 -407 225 -83 22 -121 25 -300 28 -113 2 -218 1 -235 -1z m-1189 -2736 c15 -16 -115 -199 -205 -289 -118 -118 -183 -154 -279 -154 -60 0 -66 2 -94 34 -25 28 -29 39 -24 69 25 160 337 359 543 348 29 -1 56 -5 59 -8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLetter);
export default __webpack_public_path__ + "static/media/logo-letter.1ebac3dc377a5b5ec61a4c1d874e4f5f.svg";
export { ForwardRef as ReactComponent };